<template>
	<div>
		<div ref="scrollToPoint"></div>
		<v-dialog
				class="media-dialog"
				content-class="rounded-xl"
				max-width="1000"
				persistent
				scrollable
				:value="true"
		>
			<v-card class="m-2">

				<v-card-title class="d-flex justify-space-between ma-0 ma-md-4">
					<h6>Manage Media</h6>
					<v-btn
							class="mt-n1 me-n2"
							color="black"
							depressed
							icon
							@click="cancelUpload"
					>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>

				<v-card-text class="pb-0 px-4 px-md-8 pt-4 pt-md-8 text-body-2">
					<div v-show="!draggingFiles">

						<form
								id="new-file-form"
								action="#"
								method="#"
								@submit.prevent="submitForm"
						>
							<v-row>
								<v-col>
									<v-text-field
											v-model="searchText"
											class="rounded-lg"
											:dense="$vuetify.breakpoint.smAndDown"
											label="Search..."
											outlined
											prepend-inner-icon="mdi-magnify"
											clearable
									></v-text-field>
								</v-col>
								<v-col cols="auto">
									<v-btn
											class="rounded-lg"
											color="primary"
											depressed
											:disabled="loading.cloudinary"
											outlined
											:x-large="$vuetify.breakpoint.mdAndUp"
											@click="uploadContent"
									>
										<v-icon>mdi-file-upload</v-icon>
										Upload File(s)
									</v-btn>
								</v-col>
							</v-row>
						</form>

						<div v-if="uploadProgress > 0" class="progress push mt-1"
								 style="height: 10px;">
							<div
									:aria-valuenow="uploadProgress"
									:style="'width: '+uploadProgress+'%;'"
									aria-valuemax="100"
									aria-valuemin="0"
									class="progress-bar progress-bar-striped progress-bar-animated bg-success"
									role="progressbar"
							></div>
						</div>

						<div class="bg-body-light mt-2">
							<!-- Navigation -->
							<div v-if="navSearch && isAdmin">
								<ol
										class="nav-main nav-main-horizontal nav-main-hover breadcrumb breadcrumb-alt"
								>
									<li class="nav-main-item breadcrumb-item nav-breadcrumb">
										<a class="nav-main-link active" @click.prevent="navChanged()">
											<span class="nav-main-link-name">Partner</span>
										</a>
									</li>
									<li class="nav-main-item breadcrumb-item nav-breadcrumb">
										<a
												aria-expanded="false"
												aria-haspopup="true"
												class="nav-main-link nav-main-link-submenu"
												data-toggle="submenu"
												href="#"
										>
											<span class="nav-main-link-name">{{ navSearch.entity }}</span>
										</a>
										<ul class="nav-main-submenu">
											<li v-for="entity of navEntities" class="nav-main-item">
												<a class="nav-main-link"
													 @click.prevent="navChanged(entity)">
													<span class="nav-main-link-name">{{ entity }}</span>
												</a>
											</li>
										</ul>
									</li>
									<li
											v-if="navSearch.entity && navSearch.entity != 'All'"
											class="nav-main-item breadcrumb-item nav-breadcrumb"
									>
										<a
												aria-expanded="false"
												aria-haspopup="true"
												class="nav-main-link nav-main-link-submenu"
												data-toggle="submenu"
												href="#"
										>
													<span class="nav-main-link-name">
														{{ navSearch.itemName }}
													</span>
										</a>
										<ul v-if="navSearch.entity === 'Campaigns'"
												class="nav-main-submenu">
											<li class="nav-main-item">
												<a class="nav-main-link"
													 @click.prevent="navChanged(navSearch.entity)">
													<span class="nav-main-link-name">All</span>
												</a>
											</li>
											<li v-for="campaign in campaigns" class="nav-main-item">
												<a
														class="nav-main-link"
														@click.prevent="navChanged(navSearch.entity, campaign.id)"
												>
															<span class="nav-main-link-name">
																{{ campaign.name }}
															</span>
												</a>
											</li>
										</ul>
										<ul v-if="navSearch.entity === 'Venues'"
												class="nav-main-submenu">
											<li class="nav-main-item">
												<a class="nav-main-link"
													 @click.prevent="navChanged(navSearch.entity)">
													<span class="nav-main-link-name">All</span>
												</a>
											</li>
											<li v-for="venue in venues" class="nav-main-item">
												<a
														class="nav-main-link"
														@click.prevent="navChanged(navSearch.entity, venue.id)"
												>
													<span class="nav-main-link-name">{{ venue.name }}</span>
												</a>
											</li>
										</ul>
										<ul v-else-if="navSearch.entity === 'Products'"
												class="nav-main-submenu">
											<li class="nav-main-item">
												<a class="nav-main-link"
													 @click.prevent="navChanged(navSearch.entity)">
													<span class="nav-main-link-name">All</span>
												</a>
											</li>
											<li v-for="product in products" class="nav-main-item">
												<a
														class="nav-main-link"
														@click.prevent="navChanged(navSearch.entity, product.id)"
												>
													<span class="nav-main-link-name">{{ product.name }}</span>
												</a>
											</li>
										</ul>
										<ul v-else-if="navSearch.entity === 'Deals'"
												class="nav-main-submenu">
											<li class="nav-main-item">
												<a class="nav-main-link"
													 @click.prevent="navChanged(navSearch.entity)">
													<span class="nav-main-link-name">All</span>
												</a>
											</li>
											<li v-for="deal in deals" class="nav-main-item">
												<a
														class="nav-main-link"
														@click.prevent="navChanged(navSearch.entity, deal.id)"
												>
													<span class="nav-main-link-name">{{ deal.name }}</span>
												</a>
											</li>
										</ul>
										<ul v-else-if="navSearch.entity === 'Packages'"
												class="nav-main-submenu">
											<li class="nav-main-item">
												<a class="nav-main-link"
													 @click.prevent="navChanged(navSearch.entity)">
													<span class="nav-main-link-name">All</span>
												</a>
											</li>
											<li v-for="p in packages" class="nav-main-item">
												<a
														class="nav-main-link"
														@click.prevent="navChanged(navSearch.entity, p.id)"
												>
													<span class="nav-main-link-name">{{ p.name }}</span>
												</a>
											</li>
										</ul>
										<ul v-else class="nav-main-submenu">
											<li class="nav-main-item">
												<a class="nav-main-link"
													 @click.prevent="navChanged(navSearch.entity)">
													<span class="nav-main-link-name">All</span>
												</a>
											</li>
										</ul>
									</li>
								</ol>
							</div>
							<!-- END Navigation -->
						</div>

						<v-sheet
								class="px-4 pt-2"
								rounded="lg"
								style="background: #f6faf2; border: solid 1px #e8f5e4;"
						>
							<v-tabs
									v-model="activeTab"
									background-color="transparent"
									class="position-relative z-1"
									color="primary"
									align-tabs="center"
							>
								<template
									v-for="mediaType, idx in mediaTypes"
								>
									<v-tab
											:disabled="!enableTabs.includes(mediaType.type)"
											:key="mediaType.type"
											@click.prevent="getFiles(idx)"
									>
										<v-icon class="me-2">{{ mediaType.icon }}</v-icon>
										{{ mediaType.name }}
									</v-tab>
								</template>
							</v-tabs>
						</v-sheet>

						<ui-box class="media-box mt-8">
							<v-tabs-items
									v-model="activeTab"
									class="elevation-0 full-height rounded-lg"
							>
								<v-tab-item
									v-for="mediaType in mediaTypes"
									:key="mediaType.type"
								>

									<v-container>

										<v-row v-if="pagination.total === 0" v-cloak>
											<v-col class="text-body-2 text-center">
												This folder is empty!
											</v-col>
										</v-row>

										<v-row>
											<v-col
													v-cloak
													v-for="file in files"
													cols="6"
													:key="file.url + mediaType.type"
													lg="3"
													md="4"
											>
												<v-card
														class="media-card"
														:class="{ 'file-selected': chosenFile === file }"
														:disabled="!!file.usageCount || !!file.underSize"
														elevation="0"
														:ripple="false"
														rounded="lg"
														@click="toggleFile(file)"
												>
													<v-card-title class="text-caption">
														<div class="text-truncate" :title="file.original_file_name">
															<v-icon v-if="mediaType.type === 'image'" class="me-1" small>
																mdi-file-image-outline
															</v-icon>
															<v-icon v-if="mediaType.type === 'audio'" class="me-1" small>
																mdi-volume-high
															</v-icon>
															<v-icon v-if="mediaType.type === 'video'" class="me-1" small>
																mdi-video-outline
															</v-icon>
															{{ file.original_file_name }}
														</div>
													</v-card-title>
													<v-card-text
															v-if="activeTabIs('image')"
															class="pa-0"
													>
														<v-divider class="opacity-40"></v-divider>
														<v-img
																v-if="activeTabIs('image')"
																:alt="file.name"
																aspect-ratio="1.33333333"
																contain
																:src="file.url"
														></v-img>
														<v-divider class="opacity-40"></v-divider>
													</v-card-text>
													<v-card-actions>
														<template v-if="!!file.usageCount">
															<v-flex
																	align-center
																	d-flex
																	px-1
																	text-caption
																	style="min-height: 24px;"
															>
																<v-icon class="me-1" small>mdi-alert-circle-outline
																</v-icon>
																File in use.
															</v-flex>
														</template>
														<template v-else-if="!!file.underSize">
															<v-flex
																	align-center
																	d-flex
																	px-1
																	text-caption
																	style="min-height: 24px;"
															>
																<v-icon class="me-1" small>mdi-alert-circle-outline
																</v-icon>
																Under size
																({{
																	file.meta_data?.width + 'x' + file.meta_data?.height
																}}).
																<v-tooltip activator="parent" location="top">
																	Make sure the file is larger than {{ minDimensions }}
																</v-tooltip>
															</v-flex>
														</template>
														<template v-else>
															<v-flex
																	:grey--text="chosenFile !== file"
																	grow
																	:primary--text="chosenFile === file"
																	ps-1
																	text-caption
															>
																{{
																	chosenFile === file
																			? 'File selected'
																			: 'Click to select'
																}}
															</v-flex>
															<v-flex pe-1 shrink>
																<v-simple-checkbox
																		class="me-n3"
																		color="primary"
																		:ripple="false"
																		:value="chosenFile === file"
																		@click.stop="toggleFile(file)"
																></v-simple-checkbox>
															</v-flex>
														</template>
													</v-card-actions>
												</v-card>
											</v-col>
										</v-row>

									</v-container>
								</v-tab-item>
							</v-tabs-items>

						</ui-box>

					</div>
					<div v-show="draggingFiles" id="dropzone" class="dropzone">
						<div class="dz-message" data-dz-message>
							<span>Drop file(s) here</span>
						</div>
					</div>
				</v-card-text>
				<v-card-actions class="px-4 px-md-8">
					<v-flex v-if="pagination.total" shrink>
						<v-pagination
								v-model="pagination.current_page"
								class="my-4"
								color="secondary"
								:length="pagination.last_page"
								total-visible="7"
								@input="pageNum => changePage(pageNum)"
								@next="() => changePage(pagination.current_page + 1)"
								@previous="() => changePage(pagination.current_page - 1)"
						></v-pagination>
					</v-flex>
					<v-spacer></v-spacer>
					<v-flex shrink>
						<v-btn
								class="me-2 me-md-4 rounded-lg"
								color="grey darken-1"
								depressed
								text
								@click="cancelUpload"
						>
							Cancel
						</v-btn>
						<v-btn
								class="rounded-lg"
								color="primary"
								depressed
								:disabled="!chosenFile || !chosenFile.url"
								@click="selectImage"
						>
							Select
						</v-btn>
					</v-flex>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>

</template>

<script>
import $api from '@api/api'

export default {
	name: 'BwMediaManager',
	props: {
		entity: Number | String,
		entityId: Number | String,
		timezone: String,
		partnerId: Number,
		website: String,
		facebook: String,
		isAdmin: {
			type: Boolean,
			default: true,
		},
		superAdmin: Boolean,
		navSearch: {
			type: Object,
			default: function () {
				return { entity: "image", itemId: 0, itemName: "image" };
			},
		},
		minDimensions: {
			type: [String, Boolean],
			default: '50x50'
		}
	},
	inject: ['enableTabs', 'showTab'],
	data() {
		return {
			chosenFile: {},
			files: [],
			campaigns: [],
			products: [],
			venues: [],
			deals: [],
			packages: [],
			attachment: {},
			pagination: {
				per_page: 12,
				current_page: 1,
				total: 0,
			},
			activeTab: 0,
			offset: 5,
			navEntities: [
				"All",
				"Campaigns",
				"Deals",
				"Offers",
				"Packages",
				"Products",
				"Venues"
			],
			fileSrc: "Bandwango",
			fileName: "",
			loading: {
				loading: false,
				cloudinary: false
			},
			mediaTypes: [
				{ icon: 'mdi-image-outline', name: 'Pictures', type: 'image' },
				{ icon: 'mdi-music-note-outline', name: 'Music', type: 'audio' },
				{ icon: 'mdi-video-outline', name: 'Videos', type: 'video' },
				{ icon: 'mdi-document-outline', name: 'Documents', type: 'document' }
			],
			moment: require("moment"),
			uploadProgress: 0,
			searchText: "",
			searchTimeout: null,
			draggingFiles: false,
			success_msg: "",
			error_msg: "",
			lastParams: {},
			open: false,
		};
	},

	methods: {

		activeTabIs(type) {
			return this.mediaTypes[this.activeTab].type === type;
		},

		checkActiveTabs(tabName) {
			return !!this.showTab.includes(tabName)
		},

		uploadContent() {
			this.loading.cloudinary = true;
			window.cloudinary.openUploadWidget(
					{
						cloud_name: 'Bandwango',
						upload_preset: 'Partner Files',
						folder: `partners/${this.entity}/${this.entityId}`,
						maxFileSize: 1073741824, //1GB,
						sources: [
							'local',
							'instagram',
							'facebook',
							'dropbox',
							'unsplash',
							'google_drive',
							'shutterstock'
						],
						showPoweredBy: false,
						buttonClass: 'cloudinary-button',
						buttonCaption: 'Up'
					},
					(error, result) => {
						if(!error && result && result.event === "success") {
							this.uploadCloudinaryFile(result.info)
						}
						this.loading.cloudinary = false;
					}).open();

		},

		async uploadCloudinaryFile(file) {
			try {
				file = {
					...file,
					'upload_assignment': this.entity || 0,
					'upload_assignment_id': this.entityId || 0,
				};

				await axios.post(`/cloudMedia`, file)

				// this function refetches the files
				await this.fetchFile(this.activeTab, this.navSearch);
			}
			catch (error) {
				console.error(`Failed to send out file: ${file}`, error)
			}
		},

		clearSearchText() {
			this.searchText = "";
			this.pagination.current_page = 1;
			this.fetchFile(this.activeTab);
		},
		importFile() {
			const files = this.fileName.split(',').map(x => x && x.trim()).filter(x => !!x);
			this.addMedia(files);
		},
		addMedia(files = false) {
			if(!files) files = this.$refs.file.files;

			this.formData = new FormData();
			files.forEach((f) => {
				this.formData.append("files[]", f);
			});

			let url = "/medias?";
			if(this.superAdmin) url = "/superAdmin/addMedia?";

			if(this.navSearch.entity && this.navSearch.entity != "All") {
				let entity = this.navSearch.entity.substring(
						0,
						this.navSearch.entity.length - 1
				);
				this.formData.append("uploadAssignment", entity.toLowerCase());
			}
			if(this.navSearch.itemId)
				this.formData.append("uploadAssignmentId", this.navSearch.itemId);

			if(this.navSearch.partner_id)
				url += "partnerId=" + this.navSearch.partner_id + "&";

			this.uploadProgress = 1;

			axios
					.post(url, this.formData, {
						headers: { "Content-Type": "multipart/form-data" },
						onUploadProgress: (progressEvent) => {
							this.uploadProgress = Math.floor(
									(progressEvent.loaded * 100) / progressEvent.total
							);
						},
					})
					.then((response) => {
						response.data.forEach((media) => {
							this.scaleDownImage(media);
							this.files.unshift(media);
							if(this.files.length > this.pagination.per_page) this.files.pop(); // push the last items back a page

							// auto choose the first image
							this.chosenFile = this.files[0];

							this.$forceUpdate();
						});
						// this.files = [...this.files, ...response.data];
						this.pagination.total = this.files.length; // should we just requery files?
						this.success_msg = "Image(s) uploaded successfully.";
						// this.chosenFile = this.files[this.files.length-1];
						this.resetForm();
					})
					.catch((error) => {
						this.uploadProgress = 0;
						this.error_msg = (error.response && error.response.data && error.response.data.error_msg) ||
								"Error uploading media.";
					});
		},
		navChanged(entity = "image", itemId = 0) {
			this.navSearch.entity = entity;
			this.navSearch.itemId = itemId > 0 ? itemId : 0;

			if(this.navSearch && this.navSearch.itemId) {
				if(
						["Deals", "Packages", "Products", "Venues"].indexOf(
								this.navSearch.entity
						) > -1
				) {
					const f = this[this.navSearch.entity.toLowerCase()].find(
							(x) => x.id === this.navSearch.itemId
					);
					if(f) {
						this.navSearch.itemName = f.name;
						this.navSearch.partner_id = f.partner_id;
					}
				}
			}
			else {
				this.navSearch.itemName = "All";
			}

			if(!this.navSearch.itemName) {
				this.navSearch.itemName = "All";
			}

			// reset the page to 1 if navigation changed
			this.pagination.current_page = 1;

			this.files = [];
			this.fetchFile(this.activeTab, this.navSearch);
		},
		async fetchFile(tabIdx, params = {}) {
			const type = this.mediaTypes[tabIdx]?.type;

			if(!this.isAdmin && !this.navSearch.entity && !this.navSearch.itemId) {
				this.files = [];
				return;
			}

			this.loading.loading = true;

			let page = 1;
			if(this.pagination && this.pagination.current_page > 1) {
				page = this.pagination.current_page;
			}

			const d = {
				type,
				display: this.pagination.per_page,
				page,
				searchText: this.searchText,
			};

			if(!_.isEmpty(params) || !_.isEmpty(this.lastParams)) {
				params = _.extend({}, this.lastParams, params);
				if(params.entity && params.entity != "All") {
					d.uploadAssignment = params.entity.toLowerCase();
					if(d.uploadAssignment.substring(d.uploadAssignment.length - 1, d.uploadAssignment.length) === "s")
						d.uploadAssignment = d.uploadAssignment.substring(0, d.uploadAssignment.length - 1);
				}
				if(params.itemId) {
					d.uploadAssignmentId = params.itemId;
				}
				this.lastParams = JSON.parse(JSON.stringify(params));
			}

			if(this.fileSrc == "Website" || this.fileSrc == "Facebook") {
				if(this.fileSrc == "Facebook")
					d.fromWebsite = "https://www.facebook.com/visitiowa";
				else d.fromWebsite = "https://www.traveliowa.com/";
			}

			const dimensions = this.minDimensions ? this.minDimensions.split('x') : [0, 0];
			const { data, data: { data: files } } = await $api.medias.getMedia(d);

			this.files = files.map((x) => {
				if(x.meta_data && typeof x.meta_data === 'string')
					x.meta_data = JSON.parse(x.meta_data)
				if((x.meta_data?.width && x.meta_data.width < dimensions[0]) || (x.meta_data?.height && x.meta_data.height < dimensions[1]))
					x.underSize = true;
				if(this.fileSrc == "Bandwango" && type == "image") this.scaleDownImage(x);
				return x;
			});
			delete data.data;
			this.pagination = data;
			this.loading.loading = false;
		},
		prepareToDelete(file) {
			Bandwango.helpers('swal', {
				title: 'Are you sure?',
				text: 'Are you sure you want to remove this file?',
				type: 'delete'
			}).then((result) => {
				if(result.value) {
					axios.delete('/medias/' + file.id).then((result) => {
						this.fetchFile(this.activeTab, this.navSearch);
					})
				}
			});
		},
		scaleDownImage(file) {
			if(file.url) {
				if(!file.originalURL)
					file.originalURL = JSON.parse(JSON.stringify(file.url));

				const i = file.url.indexOf("w_300");
				if(i === -1) {
					file.url = file.url.replace("upload/", "upload/w_300/");
				}
			}
		},
		getFiles(tabIdx, src = "Bandwango") {
			this.fileSrc = src;
			this.activeTab = tabIdx;
			this.files = [];
			this.fetchFile(tabIdx);
		},
		resetForm() {
			this.formData = {};
			this.fileName = "";
			this.attachment = "";
			this.searchText = "";
			this.uploadProgress = 0;
			this.open = false;
		},

		cancelUpload() {
			// clear the image previews in the uploader
			window.EventBus.$emit('media-manager-dialog', 'cancel');
			this.$emit("cancel");
			this.resetForm();
		},

		onCloseModal() {
			const modals = document.querySelectorAll('.modal.show');
			if(modals.length)
				document.body.classList.add('modal-open')
		},

		changePage(page) {
			if(page > this.pagination.last_page) {
				page = this.pagination.last_page;
			}
			this.pagination.current_page = page;
			this.fetchFile(this.activeTab);
		},
		selectImage() {
			const type = this.mediaTypes[this.activeTab]?.type;

			this.$emit("file-chosen", this.chosenFile, type);
			this.open = false;

			setTimeout(() => {
				this.resetForm();
			}, 1000);

		},
		isAdvancedUpload() {
			var div = document.createElement("div");
			return (
					("draggable" in div || ("ondragstart" in div && "ondrop" in div)) &&
					"FormData" in window &&
					"FileReader" in window
			);
		},
		async getItemData() {
			const [
				productsResponse,
				campaignsResponse,
				venuesResponse,
				dealsResponse,
				packagesResponse
			] = await Promise.all([
				$api.products.getProducts(),
				$api.campaigns.getCampaigns(),
				$api.venues.getVenues(),
				$api.deals.getDeals(),
				$api.packages.getPackages()
			]);

			this.products = productsResponse.data;
			this.campaigns = campaignsResponse.data;
			this.venues = venuesResponse.data;
			this.deals = dealsResponse.data;
			this.packages = packagesResponse.data;
		},
		getItemDataOld() {
			const self = this;

			let ajaxCounts = 5;
			// get product names
			$.ajax({
				url:
						utils.apiVersion() +
						(this.superAdmin ? "/superAdmin" : "") +
						"/products?select[]=products.name&select[]=products.id",
				type: "GET",
				dataType: "json",
				success: function (response) {
					self.products = response;

					if(--ajaxCounts === 0)
						self.navChanged(self.navSearch.entity, self.navSearch.itemId);
				},
				error: function (response) {
					self.error_msg = response.message;
				},
			});

			// get campaign names
			$.ajax({
				url:
						utils.apiVersion() +
						(this.superAdmin ? "/superAdmin" : "") +
						"/campaigns?select[]=campaigns.name&select[]=campaigns.id",
				type: "GET",
				dataType: "json",
				success: function (response) {
					self.campaigns = response;

					if(--ajaxCounts === 0)
						self.navChanged(self.navSearch.entity, self.navSearch.itemId);
				},
				error: function (response) {
					self.error_msg = response.message;
				},
			});

			// get venue names
			$.ajax({
				url:
						utils.apiVersion() +
						(this.superAdmin ? "/superAdmin" : "") +
						"/venues?select[]=venues.name&select[]=venues.id",
				type: "GET",
				dataType: "json",
				success: function (response) {
					self.venues = response;

					if(--ajaxCounts === 0)
						self.navChanged(self.navSearch.entity, self.navSearch.itemId);
				},
				error: function (response) {
					self.error_msg = response.message;
				},
			});

			// get deal names
			$.ajax({
				url:
						utils.apiVersion() +
						(this.superAdmin ? "/superAdmin" : "") +
						"/deals?select[]=deals.name&select[]=deals.id",
				type: "GET",
				dataType: "json",
				success: function (response) {
					self.deals = response;

					if(--ajaxCounts === 0)
						self.navChanged(self.navSearch.entity, self.navSearch.itemId);
				},
				error: function (response) {
					self.error_msg = response.message;
				},
			});

			// get packages names
			$.ajax({
				url:
						utils.apiVersion() +
						(this.superAdmin ? "/superAdmin" : "") +
						"/packages?select[]=packages.name&select[]=packages.id",
				type: "GET",
				dataType: "json",
				success: function (response) {
					self.packages = response;

					if(--ajaxCounts === 0)
						self.navChanged(self.navSearch.entity, self.navSearch.itemId);
				},
				error: function (response) {
					self.error_msg = response.message;
				},
			});
		},
		toggleFile(file = false) {
			if(!file) this.chosenFile = {};
			this.chosenFile = this.chosenFile === file ? {} : file;
		}
	},
	created() {
		this.activeTab = this.mediaTypes.findIndex(mediaType => mediaType.type === this.showTab);
		//if the user passes down a search then just use that. otherwise give its entity.
		this.navSearch.entity ? this.navSearch.entity : this.entity

		this.fetchFile(this.activeTab, this.navSearch);
	},
	async mounted() {
		window.EventBus.$on('media-manager-dialog', (key) => {
			if(key === 'open')
				this.open = true;
			else
				this.open = false;
		});

		// set up drag and drop
		if(this.isAdvancedUpload()) {
			const vm = this;
			const content = $("#block-content");
			const dropzoneDiv = $("#dropzone");

			content
					.on(
							"drag dragstart dragend dragover dragenter dragleave drop",
							function (e) {
								e.preventDefault();
								e.stopPropagation();
							}
					)
					.on("dragover dragenter", function () {
						$(".dropzone").attr(
								"style",
								"min-height:" + content.height() + "px !important"
						);
						vm.draggingFiles = true;
					});

			dropzoneDiv
					.on(
							"drag dragstart dragend dragover dragenter dragleave drop",
							function (e) {
								e.preventDefault();
								e.stopPropagation();
							}
					)
					.on("dragover dragenter", function () {
						vm.draggingFiles = true;
					})
					.on("dragleave dragend drop", function () {
						vm.draggingFiles = false;
					})
					.on("drop", function (e) {
						vm.addMedia(e.originalEvent.dataTransfer.files);
					});
		}

		// don't do ajax calls if user is not admin
		if(this.isAdmin) {
			await this.getItemData();
			this.navChanged(this.navSearch.entity, this.navSearch.itemId);
		}

	},

	computed: {
		pages() {
			let pages = [];

			let from = this.pagination.current_page - Math.floor(this.offset / 2);

			if(from < 1) {
				from = 1;
			}

			let to = from + this.offset - 1;

			if(to > this.pagination.last_page) {
				to = this.pagination.last_page;
			}

			while(from <= to) {
				pages.push(from);
				from++;
			}

			return pages;
		},
	},
	watch: {
		searchText: function (text) {
			if(text.length > 2) {
				if(this.searchTimeout) clearTimeout(this.searchTimeout);

				this.searchTimeout = setTimeout(() => {
					this.pagination.current_page = 1;
					this.fetchFile(this.activeTab);
				}, 1000);
			}
		},
		success_msg: function (msg) {
			if(msg) {
				One.helpers("notify", {
					align: "center",
					type: "success",
					icon: "fa fa-check mr-1",
					message: msg,
				});
				this.success_msg = "";
			}
		},
		error_msg: function (msg) {
			if(msg) {
				One.helpers("notify", {
					align: "center",
					type: "danger",
					icon: "fa fa-exclamation mr-1",
					message: msg,
				});
				this.error_msg = "";
			}
		},
		isOpen: function (o) {
			this.open = o;
		}
	},
};
</script>

<style lang="scss" scoped>

.v-dialog.media-dialog {
	height: 90vh;
}

.theme--light.v-tabs-items {
	background: none !important;
}

.v-card--link:before {
	background: none !important;
}

.v-card.media-card {
	border: solid 2px transparent !important;
	transition: border 300ms;

	&::after {
		content: '';
		border: solid 1px currentColor !important;
		height: 100%;
		width: 100%;
		top: 0;
		pointer-events: none;
		position: absolute;
		left: 0;
		border-radius: 8px;
		opacity: 0.4;
		transition: all 300ms;
	}

	&.file-selected {
		border: solid 2px var(--v-primary-base) !important;

		&::after {
			height: calc(100% + 12px);
			width: calc(100% + 12px);
			top: -6px;
			left: -6px;
			border: solid 5px var(--v-primary-base) !important;
			border-radius: 12px;
			opacity: 0.2;
		}
	}
}

.media-box {
	height: calc(90vh - 361px);
	overflow: auto;
}

::v-deep .v-pagination {
	& button {
		box-shadow: none !important;
	}
}

/* ---- */

.audio {
	overflow: hidden;

	@for $i from 1 through 9 {
		#Line_#{$i} {
			animation: pulse 1s infinite;
			animation-delay: $i * .15s;
		}
	}

	@keyframes pulse {
		0% {
			transform: scaleY(1);
			transform-origin: 50% 50%;
		}

		50% {
			transform: scaleY(.7);
			transform-origin: 50% 50%;
		}

		100% {
			transform: scaleY(1);
			transform-origin: 50% 50%;
		}
	}
}

.mm-modal {
	position: absolute;
	top: -300px;
	height: 800px;
}

.fm-file-input {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}

.image > img {
	width: 100%;
}

.file-selected {
	-webkit-box-shadow: 0 0 5px green !important;
	-moz-box-shadow: 0 0 5px green !important;
	box-shadow: 0 0 5px green !important;
}

.dz-message {
	text-align: center;
}

.form-control-clear {
	right: 60px !important;
}

.nav-breadcrumb:before {
	top: 10px !important;
	float: left !important;
}

.card-image > .card-button {
	float: right;
}

.cloudinary_fileupload {
	background: #46c37b;
}

#media-manager {
	background: rgba(0, 0, 0, 0.4);
}
</style>